// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1W69A","footer":"ReportModalFilter_footer__3Lczd"};